import {
    saveVtexIntegration,
    getVtexState,
    getVtexData,
} from './vtex.state';
import { integrationHookFactory } from '../integrations.hooks';

export const useVTEX = integrationHookFactory({
    saveAction: saveVtexIntegration,
    loadAction: getVtexData,
    stateSelector: getVtexState,
});
